<template>
  <div class="guide">
    <div class="guide-container" v-for="(item,index) in guide" :key="index">
      <div :style="{color:color}">{{item.label}}</div>
      <div :style="{color:color}" v-if="index+1<guide.length"> > </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "guide",
    props: {
      guide: {
        type: Array
      },
      color:{
        type:String,
        default:'#fff'
      }
    },
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="less">
  .guide {
    display: flex;
    margin: auto;
    .guide-container{
      display: flex;
    }
    span {
      /*color: #fff;*/
    }
  }
</style>
<style>
  @media only screen and (min-width: 320px) {
    .guide {
      width: 90% !important;
    }
  }
  @media only screen and (min-width: 640px) {
    .guide {
      width: 43rem !important;
    }
  }
  @media only screen and (min-width: 1100px){
    .guide {
      width: 48rem !important;
    }
  }
</style>
